// extracted by mini-css-extract-plugin
export default {"title":"TileNav--title--1XjBB","tiles":"TileNav--tiles--3BPQQ","tile":"TileNav--tile--1xkC6"};